export interface QuestionnaireTimberSpecies {
  id: string;
  name: string;
  latin: string;
  cost: string;
  description: string;
  swatchColor: string;
  hardness: string;
  grain: string;
  durability: string;
  pros: string[];
  cons: string[];
  imageUrl?: string;
}

export const DEFAULT_TIMBER_SPECIES: QuestionnaireTimberSpecies[] = [
  {
    id: 'white-pine',
    name: 'Eastern White Pine',
    latin: 'Pinus strobus',
    cost: '$',
    description: 'A classic New England favorite with a soft, creamy appearance that brightens any space. White Pine is easy to work with hand tools and takes stain beautifully, making it incredibly versatile.',
    swatchColor: 'linear-gradient(135deg, #E8D5B0 0%, #D4BC90 50%, #F0E2C4 100%)',
    hardness: 'Soft',
    grain: 'Even, fine',
    durability: 'Moderate',
    pros: ['Most affordable option', 'Easy to work', 'Light, airy aesthetic'],
    cons: ['Softer — dents more easily', 'Needs treatment for outdoor use'],
  },
  {
    id: 'douglas-fir',
    name: 'Douglas Fir',
    latin: 'Pseudotsuga menziesii',
    cost: '$$',
    description: 'The gold standard of timber framing. Douglas Fir offers an exceptional balance of strength, workability, and beauty. Its warm reddish-brown hue deepens with age, developing rich character over decades.',
    swatchColor: 'linear-gradient(135deg, #C17A4A 0%, #A0603A 50%, #D49A6A 100%)',
    hardness: 'Medium',
    grain: 'Straight, tight',
    durability: 'Very Good',
    pros: ['Excellent strength-to-weight ratio', 'Beautiful warm color', 'Widely available'],
    cons: ['Can check over time', 'Moderate insect resistance'],
  },
  {
    id: 'white-oak',
    name: 'White Oak',
    latin: 'Quercus alba',
    cost: '$$$',
    description: 'The heavyweight of timber framing. White Oak is incredibly strong, naturally water-resistant, and develops a gorgeous silvery patina when left unfinished. It\'s the choice for frames meant to last centuries.',
    swatchColor: 'linear-gradient(135deg, #B89B6F 0%, #9A8050 50%, #CBB285 100%)',
    hardness: 'Very Hard',
    grain: 'Prominent, tight',
    durability: 'Excellent',
    pros: ['Exceptional strength', 'Naturally water-resistant', 'Ages beautifully'],
    cons: ['Heavy — harder to work', 'Premium pricing'],
  },
];
